import { Box, Container, Typography } from "@mui/material";
import React from "react";

const HowItWorksSection = () => {
  return (
    <Box
      component="section"
      sx={{ bgcolor: "background.default", py: { xs: 6, md: 10 } }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
          px: { xs: 0, sm: 2 },
        }}
      >
        {/* Main Box to hold both image and overlapping text */}
        <Box
          sx={{
            width: "100%",
            maxWidth: 1040,
            position: "relative",
            padding: { xs: 1 },
          }}
        >
          {/* Background Image with Play Button */}
          <Box
            component="img"
            src={"websiteAssets/AboutUsVideo.png"}
            alt="How it works video"
            sx={{
              width: "100%",
              height: { xs: 240, sm: 320, md: 450 },
              objectFit: "cover",
              borderRadius: 2,
            }}
          />

          {/* Play Button */}
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: { xs: "50%", md: "30%" },
              transform: "translate(-50%, -50%)",
              width: { xs: 60, md: 80 },
              height: { xs: 60, md: 80 },
              borderRadius: "50%",
              bgcolor: "rgba(255,255,255,0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: 2,
            }}
          >
            <Box
              component="span"
              sx={{
                width: 0,
                height: 0,
                borderLeft: { xs: "16px solid #000", md: "20px solid #000" },
                borderTop: {
                  xs: "10px solid transparent",
                  md: "12px solid transparent",
                },
                borderBottom: {
                  xs: "10px solid transparent",
                  md: "12px solid transparent",
                },
              }}
            />
          </Box>

          {/* Overlapping Text Box */}
          <Box
            sx={{
              position: { xs: "static", md: "absolute" },
              top: { md: "50%" },
              right: { md: 0 },
              transform: {
                xs: "none",
                md: "translateY(-50%) translateX(20%)",
              }, // 50% overlap to the right
              bgcolor: "primary.main",
              color: "text.light",
              px: { xs: 3, md: 3 },
              py: { xs: 4, md: 6 },
              width: { xs: "100%", md: 479 },
              boxShadow: 4,
              borderRadius: 2,
              zIndex: 3,
              mt: { xs: 3, md: 0 },
              // margin: { xs: 1 },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontFamily: "Jost-Bold, Montserrat",
                fontWeight: 700,
                fontSize: { xs: "2rem", md: "3rem" },
                textAlign: "center",
                letterSpacing: { xs: "-1.5px", md: "-3px" },
                mb: { xs: 2, md: 3 },
              }}
            >
              HOW IT WORKS
            </Typography>

            <Typography
              sx={{
                fontFamily: "Poppins-Light, Montserrat",
                fontWeight: 300,
                fontSize: { xs: "0.95rem", md: "1rem" },
                textAlign: "center",
                letterSpacing: "-0.32px",
                lineHeight: 1.7,
              }}
            >
              Apna Card is a seamless digital solution for instant connections.
              Share your contact details with a tap using NFC or let others scan
              your QR code—no more paper exchanges.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HowItWorksSection;
